import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux"
import { initApp } from "store/app/app.actions";

const useInitialiseApp = (run?: boolean) => {
    const mounted = useRef(false);

    const dispatch = useDispatch();

    const init = useCallback(() => {
        if (run) {
            dispatch(initApp());
        }
    }, [dispatch, run]);

    useEffect(() => {
        // This is required to avoid running initialisation logic twice during local development on React > 18
        if (process.env.NODE_ENV !== 'development') {
            return init();
        } else {
            if (mounted.current) {
                return init();
            }

            mounted.current = true;
        }

        return () => {};
    }, [mounted, init]);

    return init;
};

export default useInitialiseApp;
